import TextoConLabel from "../../../../components/inputs/genericos/materialui/textoConLabel";
import Tabla from "../../../../components/ui/materialui/tabla";
import TableHeader from "../../../../components/ui/tableHeader";
import { useColumnsCoberturas } from "../../utils/columnsCoberturas";
import { useEffect, useMemo } from "react";
import { useParticipantes } from "../../hooks/useParticipantes";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Grid2 from "@mui/material/Grid2";
import DialogActions from "@mui/material/DialogActions";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import Divider from "@mui/material/Divider";
import ExitToAppTwoToneIcon from '@mui/icons-material/ExitToAppTwoTone';


interface IProps {
    show: boolean
    onHide: () => void
    codigo: string;
    codigoInterno: string;
    tipoSeguro: string;
    tienePrima: boolean;
    montoAsegurado: number | null;
}

const ModalPrimaCobertura: React.FC<IProps> = ({ show, onHide, codigo, codigoInterno, tipoSeguro, tienePrima, montoAsegurado }) => {
    const { obtenerCoberturas, coberturaPoliza } = useParticipantes();
    const { COLUMNS } = useColumnsCoberturas(montoAsegurado ?? 0);
    const columns = useMemo(() => COLUMNS, [montoAsegurado, tienePrima]);

    useEffect(() => {
        if (tienePrima && codigoInterno) {
            obtenerCoberturas(codigo, codigoInterno);
        }

    }, [codigo, codigoInterno, tienePrima])

    return (
        <Dialog
            open={show}
            fullWidth
            maxWidth="lg"
            onClose={onHide}
        >
            <DialogTitle>{"Primas por cobertura"}</DialogTitle>

            <DialogContent>
                <Grid2 container spacing={2}>
                    <Grid2 size={{xs: 12, md: 3}}>
                        <TextoConLabel label="Código póliza" texto={codigo} />
                    </Grid2>
                    <Grid2 size={{xs: 12, md: 3}}>
                        <TextoConLabel label="Código interno póliza" texto={codigoInterno} />
                    </Grid2>
                    <Grid2 size={{xs: 12, md: 3}}>
                        <TextoConLabel label="Tipo seguro" texto={tipoSeguro} />
                    </Grid2>
                    <Grid2 size={{xs: 12, md: 3}}>
                        <TextoConLabel label="Monto asegurado" texto={`UF ${montoAsegurado?.toString()}`} />
                    </Grid2>
                </Grid2>

                <Divider sx={{ my: 2 }} />

                <Tabla
                    columns={columns}
                    data={coberturaPoliza.map(({ codigoCobertura, tasa, prima }) => ({
                        codigoCobertura,
                        tasa,
                        prima: prima ?? 0 
                    }))}
                    titulo={<TableHeader title="Coberturas" />}
                />
            </DialogContent>

            <DialogActions>
                <MButton variant="contained" onClick={onHide} startIcon={<ExitToAppTwoToneIcon/>}>
                    Volver
                </MButton>
            </DialogActions>
        </Dialog>
    )
}

export default ModalPrimaCobertura

